/**
 * author       : zwl
 * createTime   : 2018/6/28 下午5:08
 * description  :
 */
import api from 'util/axios'

export function getAppList () {
  return api({
    method: 'get',
    url: '/app'
  })
}

export function getAppMenu (appId) {
  return api({
    method: 'get',
    url: '/app/menu/' + appId
  })
}

export function getAppUsers (appId, pageSize, pageCurrent) {
  return api({
    method: 'get',
    url: `/app/appUsers/${appId}?pageSize=${pageSize}&pageCurrent=${pageCurrent}`
  })
}

export function updateUserPermission (appId, params) {
  return api({
    method: 'put',
    url: '/app/userPermission/' + appId,
    data: params
  })
}

export function getApp (appId) {
  return api({
    method: 'get',
    url: '/app/' + appId
  })
}

export function invitedUser (appId, phone) {
  return api({
    method: 'post',
    url: '/app/invitedUser/' + appId,
    data: phone
  })
}

export function removeUser (appId, userId) {
  return api({
    method: 'post',
    url: '/app/removeUser/' + appId,
    data: userId
  })
}

export function getAppInfo (appId) {
  return api({
    method: 'get',
    url: '/app/info/' + appId
  })
}

export function createApp (params) {
  return api({
    method: 'post',
    url: '/app',
    data: params
  })
}

export function updateApp (appId, params) {
  return api({
    method: 'put',
    url: '/app/' + appId,
    data: params
  })
}

export function deleteApp (appId) {
  return api({
    method: 'delete',
    url: '/app/' + appId
  })
}
